import api from "../api";

const transactionsGraph = async (workspaceId) => {
    return api
        .get(`/v0/user/${workspaceId}/transactions/stats`, {
            headers: {
                "x-access-token": localStorage.getItem("@App:token"),
            },
        })
        .then((response) => response)
        .catch((error) => error.response);
};

const getTransactions = async (env, workspaceId) => {
    return api
        .get(`/v0/user/${workspaceId}/transactions?environment=${env}`)
        .then((response) => response.data)
        .catch((error) => error.response);
};

const getTransactionsById = async (id) => {
    return api
        .get(`/v0/user/transactions/${id}`)
        .then((response) => response.data)
        .catch((error) => error.response);
};

export { transactionsGraph, getTransactions, getTransactionsById };
